/** Deduped merge of BFF team GitHub org names and DI infrastructure org lists (order preserved: BFF first). */
export function mergeUniqueGithubOrgLists(fromBff: string[], fromDi: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  [...fromBff, ...fromDi].forEach((raw) => {
    const s = String(raw).trim();
    if (s.length > 0 && !seen.has(s)) {
      seen.add(s);
      out.push(s);
    }
  });
  return out;
}
